import React, { Component } from 'react';
import './App.css';

export default class Parcours extends Component {
    
    render() {
    return (
<div>
  <div className="titre">Parcours</div>
<p>Jorge Sancho <b>GALEGO</b></p>

<table border="0" cellpadding="0" cellspacing="0">
<tr><td>
</td><td>Né le 31 juillet 1961</td>
</tr><tr>

<td>
</td><td>à Sâo Bras De Alportel - Algarve - Portugal.

</td></tr>
</table>


<br />

<h2>Parcours artistiques</h2>

<table border="0" cellpadding="0" cellspacing="0" >

<tr>

<td>

1966</td><td>

Arrivée en France</td>

</tr>
<tr>
<td >

1968</td><td>

Sans pinceaux à l'école, se coupe une mèche de cheveux pour en fabriquer un.</td>

</tr>
<tr>
<td >

1976</td><td>Création de sept pages originales de bandes dessinées en couleurs «Captain Pacific».<br />

Deuxième prix au concours d'affiches «floralies Renault 5» - Cannes La Bocca.</td>

</tr>
<tr>
<td  nowrap>
1982-84 </td><td>Autodidacte de nature, suit néanmoins les cours de dessin et

de peinture de Josette VAUDOU à son atelier - Paris 16ème.
</td>

</tr>

</table>


<br />

<h2>Expositions personnelles</h2>

<table border="0" cellpadding="0" cellspacing="0" >

<tr>

<td >

1984</td><td>Peintures Murales Narratives (Sâo Bras de Aportel) - Algarve - Portugal.</td>

</tr>

<tr>

<td >

1987</td><td>C.L.A.L.S. - Thonon les Bains (74).</td>

</tr>

<tr>

<td  nowrap>

1987-88</td><td>Galerie «Atlante» - Paris 3ème.</td>

</tr>

<tr>

<td >

1988</td><td>Performance à l'Arsenal de Metz avec le C.C.P.F. peinture de 2m x 1.50m (Donation au musée Municipal de Metz).<br />

Décors pour le restaurant «Le Bistrot du Viaduc», 12, rue de Tolbiac - Paris l3ème.</td>

</tr>

<tr>

<td >

1991</td><td>2ème prix au concours d'illustration d'étiquettes de vin «Château Bonalgue», Boulogne-Billancourt.</td>

</tr>

<tr>

<td >

1992</td><td>Expo. «ET...GALEGO...EN DROIT» à l'espace Bar-Expo «La Picolthèque» - Paris 3ème.</td>

</tr>

<tr>

<td >

1996</td><td>Expo «Musique» à «Espace Masaï» - Paris 17ème.<br />

Réalisation d'un film d'art (6mn) «Tableaux Animés» ou «Trois paysages volcaniques».<br />

Exposition permanente (25 peintures, 3 sculptures) à Sâo Bras de Aportel - Algarve, Portugal. <br />



Exposition à l'INRA - Paris 7ème.<br />

Participation à la «Biennale du Film d'Art» avec son film d'animation («Tableaux

animés» ou «Trois paysages volcaniques») au Centre Georges Pompidou.<br />



Première lithographie tirée et réalisée à l'atelier Frank Bordas (30 exemplaires), Paris (dépôt à la B.N)<br />

Exposition pour la fête du Journal «Encontro» - 75013 Paris.</td>

</tr>

<tr>

<td  nowrap>

juin 1997</td><td> Maison de l'UNESCO - Paris 15ème «Les Pluies Acides» ou «Les Feuilles qui pleurent». <br />

Le Doobie's - Paris 5ème, «Les Poètes de la Nuit».</td>

</tr>

<tr>

<td >

1998</td><td>Galerie de Buci, 73, rue de Seine - Paris 6ème «Les Pluies Acides» ou «Les Feuilles qui pleurent».</td>

</tr>

<tr>

<td  nowrap>

sept 1999</td><td>Galerie de Buci, 73, rue de Seine - Paris 6ème «Au Cœur de la Nature».</td>

</tr>

<tr>

<td  nowrap>

oct 1999</td><td>18 œuvres au Pigeonnier de CHEVANNES - 91750.</td>

</tr>

<tr>

<td  nowrap>

fév 2000</td><td>Réalisation 2ème Film d'Art «Beautés Volcaniques» (Tableaux animés) 3mn 40.</td>

</tr>

<tr>

<td  nowrap>

mai 2000</td><td>Galerie Dépôt-Matignon 75008 Paris «Petites histoires peu ordinaires».</td></tr>

<tr>

<td  nowrap>

nov 2000</td><td>Espace Imperio - 18, rue de la pépinière 75008 Paris.

</td></tr>

<tr>

<td  nowrap>

oct 2000</td><td>Galerie «Le Poisson dans l'Arbre» en permanence - 74100 Annemasse.

</td></tr> 

<tr>

<td  nowrap>

mai 2001</td><td>Invité d'honneur du XXème Salon de Haute-Gironde, consacré au Portugal - prix de la mairie de Marcillac - 33860 Marcillac.</td>

</tr>

<tr>

<td  nowrap>

sept 2002</td><td>Auditorium de Saint Germain des Prés - 75006 Paris.

</td></tr>

<tr>

<td  nowrap>

nov 2004</td><td>Auditorium de Saint Germain des Prés - 75006 Paris.

</td></tr>

<tr>

<td  nowrap>

été 2005</td><td>Café Le Rendez-Vous des Amis - 18 modèles de Montmartre - 23, rue Gabrielle 75018 Paris.

</td></tr>
<tr>
<td  nowrap>
juin 2008</td><td>«Portraits-réflexions écologiques» sur le pont de Grenelle.

</td></tr>
<tr>
<td  nowrap>2011-2012</td>
<td>Concours affiches pour l'ONU
</td>
</tr>
<tr>
<td>2016</td>
<td>"Visao interior do meu Algarve" ,petite rétrospective de 59peintures et 6 sculptures-installations au Museu Municipal de Faro,Algarve,Portugal</td>
</tr>
</table>


<br />

<h2>Expositions collectives</h2>

<table border="0" cellpadding="0" cellspacing="0" >

<tr>

<td  nowrap>

1983</td><td>Concours international de peinture - Côte d'Azur Cannes (06).</td>

</tr>

<tr>



<td  nowrap>

1984</td><td>Concours BD «Les Fébriles Aventures de Yorick» pour la Librairie GIBERT JEUNE» 75005 Paris.</td>

</tr>

<tr>

<td  nowrap>

1985-1988</td><td>Salon des Indépendants, Grand Palais - Paris.<br />

Galerie «Espace Delpha» - Paris.<br />

Salon Mantes-la-Jolie (78).<br />

Médaille d'argent au Concours International de peinture de Deauville (14).</td>

</tr>

<tr>

<td  nowrap>

1987</td><td>«Les Seigneurs de l'Art», Art International - Arles, Aix-en-Provence, Marseille (13).<br />

Mairie du 16ème (gravures), un an de gravure avec I'ADAC - 75016 Paris.</td>

</tr>

<tr>



<td  nowrap>

1987-1989</td><td>Salon «Figuration Critique», Grand Palais - Paris.</td>

</tr>

<tr>

<td  nowrap>

1989</td><td>Galerie des Beaux-Arts de Bordeaux (33).<br />

Salon du dessin et de la peinture à l'eau, Grand Palais - Paris.<br />

Salon au Château de Saint Ouen.<br />

Galerie «Riviera» - Nice (06).<br />

Versailles Jeunesse - Artistes dans la rue (78).<br />

Galerie «Petit-pont» - Strasbourg (67).</td>

</tr>

<tr>

<td  nowrap>

1990</td><td>Galerie «Dedal» - Annemasse, avec la revue «Plages» n° 43, 44, 47, 54

(Revue tirée à 1000 exemplaires uniques et distribuée à la Librairie «la Hune» Paris 6ème).</td>

</tr>

<tr>

<td  nowrap>

1997</td><td>Galerie «Guillaume de Fontenelle» - Paris I7ème.<br />

Casa de la Juventude - Porto, Portugal.<br />

13ème GMAC - Paris Bastille.<br />

Performance peinture pour le TELETHON de ST. DENIS.</td>

</tr>

<tr>

<td  nowrap>

1998</td><td>Salon des Artistes Naturalistes MNHN  - Paris 5ème.<br />

Casa de la Juventude - Faro, Portugal.<br />

1er Festival de Peinture de Saumur (49).

</td></tr>

<tr>

<td  nowrap>

2000</td><td>Festival «Montmartre en Europe» avec le Portugal.<br />

Collection Paul Nebenzhal, San Francisco - USA.

</td></tr>

<tr>

<td  nowrap>

2001</td><td>Salon d'art contemporain de Montrouge.<br />

Dépôt au cabinet des Estampes de la Bibliothèque Nationale : 1 lithographie et 13 gravures.

</td></tr>

<tr>

<td  nowrap>

2004</td><td>"ARTE VIVA" Musée de São Bras de Alportel - Portugal.

</td></tr>

<tr>

<td  nowrap>

2004</td><td>"EXPO HP" Palais de Tokyo - Paris.

</td></tr>
<tr>
<td  nowrap>

2006</td>
<td>Art contemporain, Salon Gabriel - Hôtel de Crillon, place de la Condorde - Paris.</td>
</tr>
<tr>
<td  nowrap>

2010</td><td>5 &oelig;uvres pour les collections du musée du vivant au château de Grignon - 78850.

</td></tr>
<tr>
<td  nowrap>2011</td><td>Don d'&oelig;uvres pour l'association A.N.G.E</td>
</tr>
<tr>
<td>2014</td>
<td>2 &oelig;uvres pour fêter la révolution des oeillets du portugal à l'espace AGORA de Nanterre</td>
</tr>
</table>


<br />

<h2>Medias</h2>



<p>CD-Rom «Artistes Contemporains» ART PRESENT, 1997, vol. 1.</p>

<p>CD-Rom «J.S.GALEGO» Michel Serrano, édition 2001.
ARTENSION, juillet-août 2006, page 84...</p>




<br />

<h2>Émissions de télévision - Cinéma</h2>


<p>
Reportage TELE « MAG 5 » de 5 mn 46, sur «Les Pluies Acides».<br />

ou «Les Feuilles qui pleurent», diffusé sur la 5ème et TV5, les 17 et 21janvier 1998. RTP (Télévision portugaise) 14 juin 1997 à Porto et RTP 11 février 1998 à Faro.
<a href="https://www.dailymotion.com/video/x153zb0?collectionXid=x1wp85">[1]</a><br />

Auteur-réalisateur du court métrage «Rue de la manutention», 5mm. 2003.<br />

«Tout le monde en parle», France 2, novembre 2005.<br />

Reportage de 10mn pour la chaine TV RTPInt diffusé le 6.7.2008 <a href="https://www.dailymotion.com/video/x15da17?collectionXid=x1wp85">[1]</a><br />

20mn de reportage de Paris dernière «la muse et modèle du peintre» 2009.
</p>


<br />
<h2>Émissions de radio</h2>


<p>
Alpha «Les Pépinières Européennes pour Jeunes Artistes», 28 janvier 1998, durée 1 heure.<br />



Libertaire «Le Jardin d'Orphée», 25 sept. 1999, durée 1 heure.<br />



Aligre, février 2000 Agenda du samedi : 15 mn.<br />
</p>




<br />
<h2>Articles de journaux et livres</h2>

<p>
«La Cote des Arts» Février 1987.</p>

<p>«Plages» Revue n° 43, 44, 47, 57.</p>

<p>«Who's Who in International Art» 1988 (Annuaire Suisse).</p>



<p>«Annuaire des Beaux-Arts», éditions Thibaud, 1991, 1992,1993.</p>



<p>«L'Officiel des Arts», éditions du Chevalet | Technique des Arts 1988.</p>



<p>«Livre des Artistes Indépendants» 1985, éditions Grand Palais.</p>



<p>«Catalogues Figuration Critique» 1987, 1988, 1989.</p>

<p>«Dictionnaire des Arts plastiques Modernes et Contemporains», J.P Delarge - éditions Grund | Paris - 2001. 
    <a target="_blank" href={require('./ressources/parcours/dico1.JPG')}>[1]</a>
    <a target="_blank" href={require('./ressources/parcours/dico2.JPG')}>[2]</a>
    <a target="_blank" href={require('./ressources/parcours/dico3.JPG')}>[3]</a>
</p>



<p>Guide - Akoun des peintres.</p>



<p>Journal «O SAMBRASENSE», 30 nov. 1996, Portugal.</p>



<p>Journal «O LUSITANO», 14 juin 1997, Portugal.</p>



<p>Journal «Encontro», 16 janvier 1998 et 1er juin 1997.</p>



<p>Journal «La Nouvelle République» du Centre Ouest, 24 janv. 1999.</p>



<p>Journal «Le Courrier de l'Ouest», 25 janv. 1999.</p>



<p>Journal «Républicain», 20 oct. 1999.</p>

<p>Journal «Le Courrier de l'Ouest», 24 janv. 1999.</p>



<p>Journal «Le Républicain», 21 oct. 1999.</p>

<p>Revue «Latitudes», Cahiers Lusophones n° 3.</p>

<p>Egidio Alvaro (critique d'art, journal "Latitudes"...2000)</p>

<p>Journal «Correiro Portugués», juin 2000.</p>

<p>Journal «Le Dauphiné Libéré», éditions Annemasse 13 fév. 2001.</p>

<p>Journal «Noticias de Sâo Bras», 20 mars 2001.</p>

<p>Journal «Sud-Ouest», 16 mai 2001.</p>

<p>Journal «Haute-Gironde», 18 mai 2001.</p>

<p>Journal «Noticias de Sâo Bras», août 2004.</p>

<p>Journal «Le Monde» 2013.</p>

</div>
    );
}
}



// WEBPACK FOOTER //
// ./src/Parcours.js